import React, { useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useAfterFirstRender } from '../../hooks/useAfterFirstRender';
import styles from './tabs.module.scss';
import { applyClasses, applyProps } from '../shared/js';

const Tab = ({ isOpen, onOpen, onClose, children, ...props }) => {
  useEffect(() => {
    if (!onOpen || !isOpen) return;
    onOpen();
  }, [isOpen, onOpen]);

  useAfterFirstRender(() => {
    if (isOpen || !onClose) return;
    onClose();
  }, [isOpen, onClose]);

  return isOpen ? (
    <div
      className={cn(styles.tabContent, applyClasses(props, styles))}
      {...applyProps(props)}
    >
      {children}
    </div>
  ) : null;
};

Tab.propTypes = {
  /** The title in the tab button */
  title: PropTypes.any,
  /** Whether or not this tab is open and its contents are visible */
  isOpen: PropTypes.bool,
  /** The contents of the tab */
  children: PropTypes.any,
  /** An optional callback called when the tab is opened */
  onOpen: PropTypes.any,
  /** An optional callback called when another tab is opened */
  onClose: PropTypes.any,
};

Tab.defaultProps = {
  title: undefined,
  isOpen: undefined,
  children: undefined,
  onOpen: undefined,
  onClose: undefined,
};

export default Tab;
